import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { GlobalService } from '../_services/global.service';
const devUrl = environment.backendurl;

export interface FreemiumpersonSearchListing {
  name: string;
  count: number;
  meta: any;
}

export interface FreeTrialRequest {
  firstname?: string;
lastname?: string;
designation?: string;
workemail: string;
countrycode?: string;
phonenumber?: string;

}
@Injectable({
  providedIn: 'root'
})



export class FreemiumAPIService {

  constructor(private http: HttpClient) { }

    private screenResumeErrorHandler: Subject<any> = new Subject();
    private evaluateErrorHandler: Subject<any> = new Subject();


  getFreemiumRecommendData(requestObject: any): Observable<any> {
    let url = devUrl + "/freemium/personsearch/recommendcandidates";
    return this.http.post<any>(url, requestObject).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('Get Person Search Listing', url)));
  }

  getFreemiumPersonSearchListing(keyword: string,type: string = null,continent?: string ): Observable<FreemiumpersonSearchListing[]> {
    let url = devUrl + "/freemium/personsearch/typeaheads"
    const queryParams = { keyword: keyword };
    type && (queryParams['type'] = type);
    if(continent) queryParams['continent'] = continent;
    return this.http.get<FreemiumpersonSearchListing[]>(url, { params: queryParams }).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('Get Person Search Listing', url)))
  }

  getFreemiumTotalAggs(requestobject):  Observable<any> {
    const url = devUrl + '/freemium/personsearch/aggregates';
    return this.http.post<any>(url, requestobject).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Get Person Search Listing', url)));
  }

  freemiumParseJobDescription(description=null){
    const formData = new FormData();
    formData.append("description", description);
    const url = devUrl + "/freemium/parsejobdescription";
    return this.http.post(url, formData).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Fetch JSON params for Job Description: ', url)));
  }

  freemiumDocumentToText(file) {
    const formData = new FormData();
    formData.append("document", file);
    const url = devUrl + "/freemium/extracttext";
    return this.http.post(url, formData).pipe(map(response => { return response; } ),
    catchError(GlobalService.handleError('Extract text form document', url)));
  }

  freeTrialRegistration(request: FreeTrialRequest):  Observable<FreeTrialRequest> {
    const url = devUrl + '/freemium/freetrialregistration';
    return this.http.post<FreeTrialRequest>(url, request).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Free Trial Registration Failed', url)));
  }

  aiScreeningUploadResume(data) {
    let formData: FormData = new FormData();
    formData.append('resume', data);
    var url = devUrl + "/freemium/uploadresume"
    return this.http.post<any>(url, formData).pipe(map(response => ({ ...response, statusCode: response.status }))
    , catchError(GlobalService.handleError('Document Upload', url)));
  }

  fetchScreeningCriteriaSuggestions(payload: any): Observable<any> {
    const url = devUrl + '/freemium/fetchscreeningcriteriasuggestions';
    return this.http.post<any>(url, payload).pipe(map(response => ({ ...response, statusCode: response.status }))
      , catchError(GlobalService.handleError('Fetch Screening Criteria Suggestions', url)));
  }

  screenResumes(payload: any): Observable<any> {
    const url = devUrl + '/freemium/screenresumes';
    return this.http.post<any>(url, payload).pipe(map(response => ({ ...response, statusCode: response.status }))
      , catchError(GlobalService.handleError('Screen Resumes', url)));
  }

  downloadScreenedResumes(resumeurl: any): Observable<Blob> {
    const url = devUrl + '/freemium/downloadresume?resumeurl=' + resumeurl;
    return this.http.get(url, { responseType: 'blob' }).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Get Person Search Listing', url)));
    }

  sendAIScreeningReport(payload: any): Observable<any> {
    const url = devUrl + '/freemium/sendaiscreeningreport';
    return this.http.post(url, payload).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Send AI Screening Report', url)));
  }


  getfreemiumSkillsTaxonomy(requestbody){
    const url = devUrl + '/freemium/skill-taxonomy';
    return this.http.post<any>(url, requestbody).pipe(map(response => ({ ...response, statusCode: response.status  })),
    catchError(GlobalService.handleError('Something Went wrong', url)));
  }

  exportFreemiumSkillTaxonomy(requestbody){
    const url = devUrl + '/freemium/skill-taxonomy/export';
    return this.http.post<any>(url,requestbody).pipe(map(response => ({ ...response, statusCode: response.status  })),
    catchError(GlobalService.handleError('Something Went wrong', url))
    )
  }

    get getScreenResumeErrorHandler(): Observable<any> {
    return this.screenResumeErrorHandler.asObservable();
  }

  emitScreenResumeErrorEvent(data: any) {
    this.screenResumeErrorHandler.next(data);
  }

  get getEvaluateErrorHandler(): Observable<any> {
    return this.evaluateErrorHandler.asObservable();
  }

  emitEvaluateErrorEvent(data: any) {
    this.evaluateErrorHandler.next(data);
  }

}
